<template>
	<v-main>
		<v-card tile>
			<v-row class="d-flex justify-center" style="background-color: #1E1E1E; max-height: 48px;" dark>
				<v-col cols="8" sm="6" class="py-0">
					<v-text-field
						height="100%"
						class="rounded-0"
						background-color="black"
						dark
						solo
						flat
						placeholder="Search Presentation"
						prepend-inner-icon="mdi-magnify"
						single-line
						hide-details
						v-model="searchTitle"
						v-on:keyup.enter=" listPresentationByTitle(searchTitle) "
					></v-text-field>
				</v-col>
			</v-row>
			<v-tabs v-model="tab" icons-and-text background-color="#416D74" dark>
				<v-tab @click.prevent="listPresentationOfftrack(); ">Offtrack</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<!-- Choose Track to List Presentation -->
				<v-tab-item>
					<v-expansion-panels v-model="panel" accordion tile dark>
						<v-expansion-panel v-for="(itemDate, idxItemDate) in dateList" :key="idxItemDate">
							<v-expansion-panel-header expand-icon>
								<v-row class="d-flex align-center mx-4">
									<v-container style="padding: 0;" class="text-center">
										<span style="font-weight: bold;">{{ itemDate.value }}</span>
									</v-container>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content class="presentation">
								<v-row
									v-for="(item,index) in itemDate.presentationList"
									:key="index"
									:style="index%2 == 1 ? 'background-color:#416D74;' : 'background-color:#3B5A5F;'"
									style="margin-left: 0; margin-right: 0;"
								>
									<v-container style="padding: 0;">
										<v-row class="d-flex mx-4">
											<v-col cols="12" sm="2" class="pt-6">
												<span style="font-weight: bold;">{{ formatTime12Hours(item.dataMap.startTime) }} - {{ formatTime12Hours(item.dataMap.endTime) }}</span>
											</v-col>
											<v-col cols="12" sm="10">
												<h3>{{ item.title }}</h3>
												<div v-for="(topic, idxTopic) in item.topicList" :key="idxTopic">
													<div class="d-flex flex-row mb-2" v-for="(presenter, idxPresenter) in topic.presenterList" :key="idxPresenter">
														<v-avatar
															size="48"
															color="teal"
															style="margin-left: 0px; margin-right: 10px;"
															@click="selectedPresenterName = presenterName(presenter); selectedPresenterBio = presenter.bio; dialogBio = true; "
														>
															<img v-if="presenter.image == null" :src="baseLocation + '/resource/image/default-avatar.png'" />
															<img v-else :src="baseLocation + '/asset/file/user/' + presenter.image" />
														</v-avatar>
														<div class="mt-3">
															<a
																style="color: white; text-decoration: none;"
																@click="selectedPresenterName = presenterName(presenter); selectedPresenterBio = presenter.bio; dialogBio = true; "
															>{{ presenterName(presenter) }}</a>
															<div class="mt-2 body-2" v-if="topic.value != null">{{ topic.value }}</div>
														</div>
													</div>
												</div>
												<p class="mt-4 body-2" v-html="item.description"></p>

												<section class="accordion">
													<input type="checkbox" name="collapse" :id="item.id" />
													<div class="handle d-flex flex-row align-center">
														<label :for="item.id">
															Resources
															<i></i>
														</label>
														<v-spacer></v-spacer>
														<v-btn
															rounded
															small
															v-if="item.type == typeOnDemandVideo"
															color="#EB7226"
															class="ma-6 px-12"
															:to="'/' + tenantSlug + '/' + experienceSlug + '/presentation/' + 0 + '/' + item.dataMap.presentationScheduleId + '/' + item.id"
														>Start</v-btn>
														<v-btn
															v-else-if="item.type == typeZoomWebinar && item.dataMap.toEndTime >= 0"
															rounded
															color="#EB7226"
															class="ma-6 px-12"
															:to="'/' + tenantSlug + '/' + experienceSlug + '/presentation/' + 0 + '/' + item.dataMap.presentationScheduleId + '/' + item.id"
														>Start</v-btn>
														<v-btn
															v-else-if="item.type == typeZoomMeeting && item.dataMap.toEndTime >= 0"
															rounded
															color="#EB7226"
															class="ma-6 px-12"
															:to="'/' + tenantSlug + '/' + experienceSlug + '/presentation/' + 0 + '/' + item.dataMap.presentationScheduleId + '/' + item.id"
														>Start</v-btn>
														<v-btn
															v-else-if="item.type == typeVimeoLive && item.dataMap.toEndTime >= 0"
															rounded
															color="#EB7226"
															class="ma-6 px-12"
															:to="'/' + tenantSlug + '/' + experienceSlug + '/presentation/' + 0 + '/' + item.dataMap.presentationScheduleId + '/' + item.id"
														>Start</v-btn>
														<v-btn
															v-else-if="item.type == typePreRecordedVideo && item.dataMap.toStartTime <= 600"
															rounded
															color="#EB7226"
															class="ma-6 px-12"
															:to="'/' + tenantSlug + '/' + experienceSlug + '/presentation/' + 0 + '/' + item.dataMap.presentationScheduleId + '/' + item.id"
														>Start</v-btn>
														<span
															v-if="item.type != typeOnDemandVideo && item.dataMap.toStartTime >= 0"
														>Scheduled to start in {{ formatTime(item.dataMap.toStartTime) }}</span>
														<span
															v-if="(item.type == typeZoomWebinar || item.type == typeZoomMeeting || item.type == typeVimeoLive) && item.dataMap.toEndTime < 0"
														>This live session has ended</span>
													</div>
													<div class="content" v-for="(itemHandout, idxItemHandout) in item.handoutList" :key="idxItemHandout">
														<v-row class="py-2" v-if="itemHandout">
															<v-col cols="12" sm="6">
																<v-icon>mdi-file-document-outline</v-icon>
																<span>{{ itemHandout.title }}</span>
															</v-col>
															<v-col cols="12" sm="4">
																<v-btn rounded small color="#EB7226" class="mx-4" v-if="itemHandout" @click="saveToMyDocument(itemHandout.id)">Save To My Document</v-btn>
															</v-col>
															<v-col cols="12" sm="2">
																<v-btn rounded small color="#EB7226" class="mx-4" v-if="itemHandout" @click="download(itemHandout.value)">View</v-btn>
															</v-col>
														</v-row>
														<hr class="mx-n4" v-if="itemHandout" />
													</div>
												</section>
											</v-col>
										</v-row>
									</v-container>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-tab-item>
			</v-tabs-items>
		</v-card>

		<v-dialog v-model="dialogBio" persistent width="800">
			<v-card tile>
				<v-card-title>
					<span class="headline">{{ selectedPresenterName }}</span>
					<v-spacer></v-spacer>
					<v-icon @click="dialogBio = false;">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>{{ selectedPresenterBio }}</v-card-text>
			</v-card>
		</v-dialog>
	</v-main>
</template>

<script>
import axios from "axios";

export default {
	props: ["tenantSlug", "experienceSlug"],
	data() {
		return {
			valid: true,
			tab: null,
			trackList: null,
			searchTitle: null,
			dateList: [],
			presentationList: [],
			presentationScheduleList: [],
			typeOnDemandVideo: "On-Demand Video",
			typePreRecordedVideo: "Pre-recorded Video",
			typeZoomWebinar: "Zoom Webinar",
			typeZoomMeeting: "Zoom Meeting",
			typeVimeoLive: "Vimeo Live",
			experienceId: null,
			timeout: null,
			dialogBio: false,
			panel: null,
			selectedPresenterName: null,
			selectedPresenterBio: null,
			baseLocation: axios.defaults.baseURL
		};
	},
	mounted() {
		this.listPresentationOfftrack();
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.panel = from.query.panel;
		});
	},
	beforeRouteLeave(to, from, next) {
		to.query.panel = this.panel;
		next();
	},
	methods: {
		listPresentationOfftrack() {
			this.presentationList = null;
			this.dateList = null;
			axios
				.post("/system/presentation/track/list", {
					trackId: null,
					offtrack: true
				})
				.then(response => {
					this.dateList = response.data;
				})
				.catch(() => {})
				.finally(() => {
					this.countDownTimer();
				});
		},
		listPresentationByTitle(title) {
			axios
				.post("/system/presentation/track/list", {
					trackId: null,
					offtrack: true,
					title: title
				})
				.then(response => {
					this.dateList = response.data;
				})
				.catch(() => {})
				.finally(() => {
					this.countDownTimer();
				});
		},
		countDownTimer() {
			for (let presentation of this.presentationList) {
				if (presentation.dataMap.toStartTime != null) {
					if (presentation.dataMap.toStartTime >= 0) {
						presentation.dataMap.toStartTime -= 1;
						presentation.dataMap.toLiveTime += 1;
						this.$forceUpdate();
					}
				}
			}
			this.timeout = setTimeout(() => {
				clearTimeout(this.timeout);
				this.countDownTimer();
			}, 1000);
		},
		download(name) {
			location.href = this.baseLocation + "/asset/file/" + name + "?download&time=" + new Date();
		},
		saveToMyDocument(id) {
			axios.post("/system/document/briefcase/add", {
				experienceUserId: this.$store.state.principal.id,
				documentId: id
			});
		},
		presenterName(presenter) {
			return (
				"" + this.$root.textify(presenter.firstName) + this.$root.textify(presenter.lastName, " ") + this.$root.textify(presenter.title, ", ")
			);
		},
		profilePicture(imageName) {
			return this.baseLocation + "/asset/file/user/" + imageName;
		},
		formatTime(seconds) {
			return new Date(seconds * 1000).toISOString().substr(11, 8);
		},
		formatTime12Hours(time) {
			time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				time = time.slice(1);
				time[5] = +time[0] < 12 ? "AM" : "PM";
				time[0] = +time[0] % 12 || 12;
			}

			return time.join("");
		}
	}
};
</script>

<style>
.presentation > .v-expansion-panel-content__wrap {
	padding: 0;
}
.presentation-search > .v-toolbar__content {
	width: 40%;
}

/*
 CSS for the main interaction
*/
.accordion > input[type="checkbox"] {
	position: absolute;
	left: -100vw;
}

.accordion .content {
	overflow-y: hidden;
	height: 0;
	transition: height 0.3s ease;
}

.accordion > input[type="checkbox"]:checked ~ .content {
	height: auto;
	overflow: visible;
}

.accordion label {
	display: block;
}

/*
 Styling
*/

.accordion {
	margin-bottom: 1em;
}

.accordion > input[type="checkbox"]:checked ~ .content {
	padding: 15px;
	border-top: 0;
}

.accordion .handle {
	margin: 0;
	line-height: 1.2em;
	height: 50px;
	border-bottom: 2px solid white;
}

.accordion label {
	color: #fff;
	cursor: pointer;
	font-weight: normal;
	padding: 15px;
}

.accordion .handle i:before {
	font: normal normal normal 24px/1 "Material Design Icons";
	content: "\F0140";
	display: inline-block;
	margin-right: 10px;
	font-size: inherit;
	line-height: 1.556em;
	vertical-align: middle;
}

.accordion > input[type="checkbox"]:checked ~ .handle i:before {
	content: "\F0143";
}
</style>

